import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import type { TGetRevenueReportRequest, TGetRevenueReportResponse } from '/src/lib/types';

export class RevenueService {
  /**
   * Formats/calculates Revenue response data
   */
  private static _interceptor = (revenue: any) => {
    const costs: any[] = [];

    for (const company of revenue.byCompany) {
      costs.push({
        amount: company.total,
        company: company.name,
        chartTitle: 'costs',
      });
    }

    return costs;
  };

  /**
   * Get Revenue report
   */
  public static async get(req: TGetRevenueReportRequest): CancelablePromise<TGetRevenueReportResponse> {
    return this._interceptor(
      await __request(OpenAPI, {
        method: 'GET',
        url: '/reports/revenue',
        query: req,
      })
    );
  }
}
